import React from 'react'

interface Props {}

const ContactPage: React.FC<Props> = () => {
  return <div>DUVIDAS</div>
}

export default ContactPage
